/* eslint-disable @repo/internal/react/require-jsdoc */

import React from 'react';

import { format } from 'date-fns';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Text, xcss } from '@atlaskit/primitives';

import type { BlogMeta } from './types';

const rootStyles = xcss({
	backgroundColor: 'elevation.surface.sunken',
	padding: 'space.200',
	borderRadius: 'radius.large',
});

export const BlogInfo = ({ meta }: { meta: BlogMeta }) => (
	<Inline
		xcss={rootStyles}
		alignInline="start"
		alignBlock="center"
		space="space.050"
		separator={<Text>·</Text>}
		shouldWrap={true}
	>
		<Text size="small" color="color.text.subtle">
			{meta.canonicalUrl ? 'Originally published on ' : ''}
			{format(meta.publishDate, 'LLL d, yyyy')}
		</Text>
		<Text size="small" color="color.text.subtle">
			{meta.readTime}
		</Text>
		<Text size="small" color="color.text.subtle">
			{meta.type}
		</Text>
		<Text size="small" color="color.text.subtle">
			{meta.author}
		</Text>
	</Inline>
);
